import { Product } from "@transfr-inc/dashboard-components/constants";
import {
  formatDateTwoDigits,
  formatTimestap,
} from "@transfr-inc/dashboard-components/utils";

import { Role } from "@models/role";

export function getOrganizationStats({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const getOrganizationStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorStats(userId, filters);
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationStats(orgCode, filters);
    } else {
      return organizationService.getOrganizationStats(orgCode, filters);
    }
  };

  return getOrganizationStatsRequest();
}

export function getOrganizationDailyStats({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const getOrganizationDailyStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorDailyStats(userId, filters);
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationDailyStats(
        orgCode,
        filters
      );
    } else {
      return organizationService.getOrganizationDailyStats(orgCode, filters);
    }
  };

  return getOrganizationDailyStatsRequest();
}

export function getCeOrganizationStats({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const filtersWithProduct = { productId: Product.CE, ...filters };

  const getCeOrganizationStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorCeStats(
        userId,
        filtersWithProduct
      );
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationCeStats(
        orgCode,
        filtersWithProduct
      );
    } else {
      return organizationService.getOrganizationCeStats(
        orgCode,
        filtersWithProduct
      );
    }
  };

  return getCeOrganizationStatsRequest();
}

export function getCeOrganizationTopCareers({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const getCeOrganizationTopCareersRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorTopCareers(userId, filters);
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationTopCareers(
        orgCode,
        filters
      );
    } else {
      return organizationService.getOrganizationTopCareers(orgCode, filters);
    }
  };
  return getCeOrganizationTopCareersRequest();
}

export function getCeOrganizationDailyStats({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const filtersWithProduct = { productId: Product.CE, ...filters };

  const getCeOrganizationDailyStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorDailyCeStats(
        userId,
        filtersWithProduct
      );
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationDailyCeStats(
        orgCode,
        filtersWithProduct
      );
    } else {
      return organizationService.getOrganizationDailyCeStats(
        orgCode,
        filtersWithProduct
      );
    }
  };

  return getCeOrganizationDailyStatsRequest();
}

export function exportOrganizationStats({
  organizationService,
  role,
  code,
  filters,
  fileName,
  getMultiOrg = false,
}) {
  const getExportOrganizationStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.exportInstructorStats(code, filters, fileName);
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.exportMultiOrganizationStats(
        code,
        filters,
        fileName
      );
    } else {
      return organizationService.exportOrganizationStats(
        code,
        filters,
        fileName
      );
    }
  };

  return getExportOrganizationStatsRequest();
}

export function exportOrganizationCeStats({
  organizationService,
  role,
  orgCodeOrUserId,
  filters,
  fileName,
  getMultiOrg = false,
  options,
}) {
  const filtersWithProduct = { productId: Product.CE, ...filters };

  const getExportOrganizationCeStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.exportInstructorCeStats(
        orgCodeOrUserId,
        filtersWithProduct,
        fileName,
        options
      );
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.exportMultiOrganizationCeStats(
        orgCodeOrUserId,
        filtersWithProduct,
        fileName,
        options
      );
    } else {
      return organizationService.exportOrganizationCeStats(
        orgCodeOrUserId,
        filtersWithProduct,
        fileName,
        options
      );
    }
  };
  return getExportOrganizationCeStatsRequest();
}

export function getProgramOrganizationStats({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const filtersWithProduct = { productId: Product.PROG, ...filters };

  const getProgramOrganizationStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorProgStats(
        userId,
        filtersWithProduct
      );
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationProgStats(
        orgCode,
        filtersWithProduct
      );
    } else {
      return organizationService.getOrganizationProgStats(
        orgCode,
        filtersWithProduct
      );
    }
  };

  return getProgramOrganizationStatsRequest();
}

export function getProgramOrganizationDailyStats({
  organizationService,
  userId,
  role,
  orgCode,
  filters,
  getMultiOrg = false,
}) {
  const getProgramOrganizationDailyStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.getInstructorDailyProgStats(userId, filters);
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.getMultiOrganizationDailyProgStats(
        orgCode,
        filters
      );
    } else {
      return organizationService.getOrganizationDailyProgStats(
        orgCode,
        filters
      );
    }
  };

  return getProgramOrganizationDailyStatsRequest();
}

export function getStatsFileName(orgName, dateRange) {
  const { startDate, endDate } = dateRange;
  const startDateFormatted = formatDateTwoDigits(startDate.split("-"));
  const endDateFormatted = formatDateTwoDigits(endDate.split("-"));

  return `${orgName} Insights [${startDateFormatted} - ${endDateFormatted}] - ${formatTimestap()}`;
}

export function exportOrganizationProgramStats({
  organizationService,
  role,
  orgCodeOrUserId,
  filters,
  fileName,
  getMultiOrg = false,
  options,
}) {
  const filtersWithProduct = { productId: Product.PROG, ...filters };

  const getExportOrganizationProgramStatsRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return organizationService.exportInstructorProgStats(
        orgCodeOrUserId,
        filtersWithProduct,
        fileName,
        options
      );
    } else if (
      (role === Role.MULTI_ORG_ADMIN.id || role === Role.MULTI_ORG_VIEWER.id) &&
      getMultiOrg
    ) {
      return organizationService.exportMultiOrganizationProgStats(
        orgCodeOrUserId,
        filtersWithProduct,
        fileName,
        options
      );
    } else {
      return organizationService.exportOrganizationProgStats(
        orgCodeOrUserId,
        filtersWithProduct,
        fileName,
        options
      );
    }
  };
  return getExportOrganizationProgramStatsRequest();
}
